//------------------------------------------------------------------------
// Top Hat component.
// Related to:
// web/app/themes/pan-wp/resources/views/partials/top-hat.blade.php
//------------------------------------------------------------------------
"use strict";

export default class TopHat {
  constructor(el) {
    this.el = el;
    this.closeButton = this.el.querySelector(".TopHat-close");
    this.titleEl = this.el.querySelector(".TopHat-contentWrapper-title");
    this.contentEl = this.el.querySelector(".TopHat-contentWrapper-message");
    this.buttonContentEl = this.el.querySelector(".TopHat-contentWrapper-button",);

    // Listen for clicks on close button
    this.closeButton.addEventListener("click", () => {
      this.setLocalStorage();
      this.close();
    });
  }

  setLocalStorage() {
    // Save promo info in localStorage, including date so we can allow it to expire
    // https://stackoverflow.com/a/4275854/673457
    let data = {
      title: this.titleEl.textContent.trim(),
      content: this.contentEl.textContent.trim(),
      button: this.buttonContentEl.textContent.trim(),
      date: new Date().getTime()
    };

    localStorage.setItem("tophat", JSON.stringify(data));
  }

  close() {
    this.setLocalStorage();

    // Hide promo (class must match donation_promo.blade.php and _donation-promo.scss)
    document.body.classList.remove("show-topHat");
  }
}

const init = () => {
  let el = document.querySelector(".TopHat");

  if (el) {
    new TopHat(el);
  }
};

// Init on initial page load
init();
